/**
 * regalo — uno strumento a canone acceso GRATIS dalla piattaforma per un'azienda, fino a una data o senza scadenza
 * (atlante cap. 251, tappa 4).
 *
 * Come funziona:
 *  - la capability va in `modules.override`, le regalie del super utente che il webhook di Stripe non tocca (è padrone
 *    solo degli strumenti pagati, in `modules.addon`): lo strumento funziona senza abbonamento e non si addebita niente,
 *    perché non è nell'abbonamento;
 *  - il perché e la durata stanno in `billing.regali.<capability>`: { attuale: { dal, fino_al, motivo, da } | null,
 *    storico: [...], avvisato_scadenza }. Scritti SOLO dal server (`billing` e `modules` sono protetti dalle regole);
 *  - sette giorni prima della fine gli amministratori vengono avvisati, alla fine lo strumento si spegne da solo
 *    (`scadenzaRegaliStrumenti`), con un altro avviso: per continuare lo attivano loro, alle loro condizioni.
 *
 * Non si regala uno strumento che l'azienda ha già nell'abbonamento: per farglielo pagare meno, o niente, si usano le
 * condizioni su misura (`suMisura.ts`).
 *
 * Nucleo PURO, condiviso fra gestionale, console e server.
 */

export interface RegaloDelloStrumento {
  readonly dal_ms: number | null;
  /** null = senza scadenza. */
  readonly fino_al_ms: number | null;
  readonly motivo: string;
}

/** Quanti giorni prima della fine si avvisa. */
export const GIORNI_DI_PREAVVISO = 7;

function millisecondi(v: unknown): number | null {
  if (typeof v === 'number') return Number.isFinite(v) ? v : null;
  if (typeof v !== 'object' || v === null) return null;
  const o = v as { toMillis?: unknown; seconds?: unknown; _seconds?: unknown };
  if (typeof o.toMillis === 'function') return (o.toMillis as () => number)();
  const s = typeof o.seconds === 'number' ? o.seconds : typeof o._seconds === 'number' ? o._seconds : null;
  return s === null ? null : s * 1000;
}

/** Il regalo in corso dello strumento per l'azienda, o null. Un regalo già scaduto non vale più. */
export function regaloDallAzienda(datiAzienda: unknown, capability: string, oraMs: number): RegaloDelloStrumento | null {
  const billing = (datiAzienda as { billing?: { regali?: Record<string, unknown> } } | null | undefined)?.billing;
  const voce = billing?.regali?.[capability] as { attuale?: unknown } | undefined;
  const a = voce?.attuale as Record<string, unknown> | null | undefined;
  if (!a || typeof a !== 'object') return null;
  const fino = millisecondi(a.fino_al);
  if (fino !== null && fino <= oraMs) return null;
  return { dal_ms: millisecondi(a.dal), fino_al_ms: fino, motivo: typeof a.motivo === 'string' ? a.motivo : '' };
}

/** Cosa fare oggi di un regalo: avvisare che sta per finire, spegnerlo perché è finito, o niente. Pura. */
export function cosaFareDelRegalo(datiAzienda: unknown, capability: string, oraMs: number): 'avvisa_scadenza' | 'spegni' | 'niente' {
  const billing = (datiAzienda as { billing?: { regali?: Record<string, unknown> } } | null | undefined)?.billing;
  const voce = billing?.regali?.[capability] as { attuale?: Record<string, unknown> | null; avvisato_scadenza?: unknown } | undefined;
  const fino = millisecondi(voce?.attuale?.fino_al);
  if (!voce?.attuale || fino === null) return 'niente';
  if (fino <= oraMs) return 'spegni';
  if (fino - oraMs <= GIORNI_DI_PREAVVISO * 86_400_000 && voce.avvisato_scadenza !== true) return 'avvisa_scadenza';
  return 'niente';
}
